import { popStore } from '@/helper/popStore';
import { computed } from 'vue';

export var fieldFactory = (name, storeId) => {
    return computed({
        get() {
            return popStore.value.find((object) => {
                return object.id === storeId
            })[name]
        },
        set(newValue) {
            popStore.value.find((object) => {
                return object.id === storeId
            })[name] = newValue;
        }
    })
}
